import { useState } from "react";
import { rpcCall } from "../ws/client";
import { Button } from "./ui";
import { toast } from "./ui/Toast";
import "../styles/DealChat.scss";

interface DealMessageModalProps {
    dealId: string;
    currentWallet: string;
    counterpartyRole: string; // "Продавец" или "Покупатель"
    onClose: () => void;
}

export default function DealMessageModal({ 
    dealId, 
    currentWallet, 
    counterpartyRole, 
    onClose 
}: DealMessageModalProps) {
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);

    const handleSend = async () => {
        if (!message.trim() || sending) return;

        setSending(true);
        try {
            const response = await rpcCall<any, { success: boolean }>(
                "deal.message.send",
                {
                    deal_id: dealId,
                    wallet: currentWallet,
                    message: message.trim()
                }
            );

            if (response.result?.success) {
                toast.success("Сообщение отправлено в Telegram");
                onClose();
            } else if (response.error) {
                toast.error(response.error.message);
            }
        } catch (err: any) {
            console.error("Failed to send message:", err);
            toast.error(err.message || "Не удалось отправить сообщение");
        } finally {
            setSending(false);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && e.ctrlKey) {
            handleSend();
        } else if (e.key === "Escape") {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content deal-message-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>💬 Написать {counterpartyRole.toLowerCase()}у</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                
                <div className="modal-body">
                    <p className="modal-hint">
                        Сообщение будет отправлено в Telegram {counterpartyRole.toLowerCase()}а
                    </p>
                    <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder="Введите сообщение..."
                        maxLength={1000}
                        rows={6}
                        autoFocus
                        disabled={sending}
                    />
                    <div className="char-counter">
                        {message.length} / 1000
                    </div>
                </div>
                
                <div className="modal-footer">
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        disabled={sending}
                    >
                        Отмена
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSend}
                        disabled={!message.trim() || sending}
                        loading={sending}
                    >
                        {sending ? "Отправка..." : "📤 Отправить"}
                    </Button>
                </div>
                
                <div className="modal-hint-footer">
                    💡 Нажмите Ctrl+Enter для отправки
                </div>
            </div>
        </div>
    );
}
